import React, { useEffect, useState } from "react";
import Input from "../input/Input";
import {getBulkDropdownData} from "../../api/keyvalue";
import Dropdown from "../input/Dropdown";
import Button from "../input/Button";

function TaxSearch({ searchResHandler, resetHandler }) {
  // ✅ Calculate default dates
  const today = new Date().toISOString().split("T")[0]; // Today
  const weekAgo = new Date();
  weekAgo.setDate(weekAgo.getDate() - 7); // 7 days ago
  const formattedWeekAgo = weekAgo.toISOString().split("T")[0];

  const [type, setType] = useState(null);
  const [dType, setDType] = useState(null);
  const [fromDate, setFromDate] = useState(formattedWeekAgo);
  const [toDate, setToDate] = useState(today);
  const [taxCode, setTaxCode] = useState("");

  const [typeOptions, setTypeOptions] = useState([]);
  const [dTypeOptions, setDTypeOptions] = useState([]);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [status, setStatus] = useState(2);
  const [statusOpt, setStatusOpt] = useState([]);

  useEffect(() => {
    (async () => {
      const {
        status,
        tax_type: typeData,
        tax_calc: dTypeData
      } = await getBulkDropdownData([
        { key: "tax_type" },
        { key: "status" },
        { key: "tax_calc" },
      ]);
      setTypeOptions(typeData);
      setDTypeOptions(dTypeData);
      setStatusOpt(status);
    })();
  }, []);

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setType(null);
    setDType(null);
    setFromDate("");
    setToDate("");
    resetHandler();
  };

  const onSearch = (e) => {
    e.preventDefault();
    searchResHandler({
      type: type,
      dtype: dType,
      code: taxCode,
      status: status,
      fromDate: fromDate,
      toDate: toDate,
    });
  };

  useEffect(() => {
    if (resetSearchFields) {
      setResetSearchFields(false);
    }
  }, [resetSearchFields]);

  return (
    <>
      <form className="ui form">
        <h4 className="ui dividing header">Tax Search</h4>
        <div
          className="four fields"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Dropdown
            label="Tax Type"
            placeholder="Tax Type"
            options={typeOptions}
            style={{ height: "20px" }}
            value={type}
            onChange={(e, data) => {
              setType(data.value);
            }}
          />
          <Dropdown
            required={false}
            label="Tax Calc"
            placeholder="Tax Calc"
            options={dTypeOptions}
            style={{ height: "20px" }}
            value={dType}
            onChange={(e, data) => {
              setDType(data.value);
            }}
          />
          <Input
            label="From Date"
            type="date"
            name="fromDate"
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);
            }}
          />

          <Input
            label={"To Date"}
            type="date"
            name="toDate"
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
            }}
          />
        </div>
        <div className="two fields">
          <Input
            type="text"
            label="Tax Code"
            placeholder="Tax code"
            value={taxCode}
            onChange={(e) => setTaxCode(e.target.value)}
          />
          <Dropdown
            label="Status"
            placeholder="Select Status"
            options={statusOpt}
            value={status}
            onChange={(e, data) => setStatus(data.value)}
          />
        </div>
        <div className="field">
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div className="field" style={{ width: "100%" }}>
              <Button template="search" onClick={onSearch} />
              <Button template="searchReset" onClick={onReset} />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default TaxSearch;
